<template>
  <BtnFlotWA />
  <section> <Navbar /> </section>

  <!-- Banners -->
  <section class="brand-header-section" v-if="currentBrandData">
    <div class="brand-banner-container">
      <img class="bannerestatico" :src="currentBrandData.banner" :alt="currentBrandData.name" />
    </div>
  </section>

  <!-- Marcas-->
  <h1 class="brands-label">Selecciona una marca</h1>
  <div class="brands-chips-container">
    <div class="brands-chips-scroll">
      <!-- Marcas Destacadas -->
      <button 
        v-for="b in featuredBrands"  :key="b.name" type="button" class="brand-chip"
        :class="{ active: selectedBrand === b.name }" @click="selectBrand(b.name)">
        {{ b.name }}
      </button>

      <button  type="button" class="brand-chip btn-more-brands"
        @click="isBrandModalOpen = true"> + Ver todas ({{ allBrandsList.length }})
      </button>
    </div>
  </div>

  <!-- MODAL MARCAS -->
  <transition name="modal-fade">
    <div v-if="isBrandModalOpen" class="brand-modal-overlay" @click.self="isBrandModalOpen = false">
      <div class="brand-modal-content">
        <div class="brand-modal-header">
          <div class="brand-modal-title">
            <h2>Selecciona tu marca favorita</h2>
          </div>
          <button class="brand-modal-close" @click="isBrandModalOpen = false" aria-label="Cerrar modal">×</button>
        </div>

        <div class="brand-modal-search">
          <span class="search-icon">🔍</span>
          <input type="text" v-model="modalBrandSearch" 
            placeholder="Buscar marca por nombre..." />
          <button v-if="modalBrandSearch" class="clear-modal-search" @click="modalBrandSearch = ''">×</button>
        </div>

        <div class="brand-modal-letters">
          <button class="letter-btn" :class="{ active: selectedLetter === 'ALL' }"
            @click="selectedLetter = 'ALL'" >Todas
          </button>
          <button v-for="letter in availableLetters"  :key="letter"
            class="letter-btn" :class="{ active: selectedLetter === letter }"
            @click="selectedLetter = letter" >
              {{ letter }}
          </button>
        </div>

        <div class="brand-modal-body">
          <div v-if="modalFilteredBrands.length === 0" class="no-brands-found">
            No se encontraron marcas que coincidan con " {{ modalBrandSearch }} ".
          </div>

          <div class="brand-grid">
            <button v-for="brandName in modalFilteredBrands" :key="brandName"
              class="brand-modal-card" :class="{ active: selectedBrand === brandName }"
              @click="selectBrand(brandName)" >
              {{ brandName }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </transition>


  <section class="catalog-container">
    <aside class="sidebar">
      <!-- CATEGORÍAS EN SIDEBAR -->
      <div class="filter-section">
        <h4 class="h4"> CATEGORIAS </h4>
        <label v-for="cat in categories" :key="cat">
          <input type="radio" :value="cat" v-model="selectedCategory" /> {{ cat }}
        </label>
      </div>

        
      <!-- DISPONIBILIDAD-->
      <div class="filter-section">
        <h4 class="h4">DISPONIBILIDAD</h4>
        <label><input type="radio" value="all" v-model="stockFilter"> Todos </label>
        <label><input type="radio" value="inStock" v-model="stockFilter"> Stock </label>
        <label><input type="radio" value="outStock" v-model="stockFilter"> Pre-orden</label>
      </div>
    </aside>

    <main class="catalog-content mobile-category-wrapper">
      <div class="contenedor-grid">
        <div class="columna">
          <div class="mobile-filters-top">
            <button class="mobile-category-button" @click="filtersOpen = !filtersOpen" :aria-expanded="filtersOpen"> 
              <span class="category-button-left"> 
                <span class="pCategory">Categorías</span> 
              </span>
              <span class="category-button-right"> 
                <span v-if="selectedCategory !== 'Todos'" class="selected-category-name"> -- {{ selectedCategory }} </span> 
                <span class="category-chevron" :class="{ open: filtersOpen }"> ⌄ </span> 
              </span> 
            </button>

            <!-- Dropdown Mobile --> 
            <transition name="category-dropdown"> 
              <div v-if="filtersOpen" class="mobile-category-dropdown"> 
                <div class="category-dropdown-header"> 
                  <span> </span> 
                  <button class="category-dropdown-close" @click="closeMobileFilters" aria-label="Cerrar categorías"> X </button> 
                </div>  

                <div class="mobile-category-chips"> 
                  <button v-for="category in categories" :key="category" 
                    type="button"  class="mobile-category-chip" 
                    :class="{ active: selectedCategory === category }" 
                    @click="selectMobileCategory(category)"> 
                    {{ category }} 
                  </button> 
                </div>  
                <div class="mobile-stock-section"> 
                  <span class="stock-title"> Disponibilidad </span> 
                  <div class="mobile-stock-chips"> 
                    <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'all' }" @click="stockFilter = 'all'"> Todos </button> 
                    <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'inStock' }" @click="stockFilter = 'inStock'"> En stock </button> 
                    <button type="button" class="mobile-category-chip" :class="{ active: stockFilter === 'outStock' }" @click="stockFilter = 'outStock'"> Pre-orden </button> 
                  </div> 
                </div> 

                <div v-if="selectedCategory !== 'Todos' || selectedGama !== 'Todas' || stockFilter !== 'all' || selectedBrand !== 'Todas'" class="mobile-category-footer"> 
                  <button type="button" class="mobile-clear-button" @click="clearFilters"> 
                    Limpiar filtros 
                  </button> 
                </div> 
              </div> 
            </transition>
          </div>
        </div>

        
      </div>

      <div class="toolbar">
        <p> Mostrando {{ filteredProducts.length ? (currentPage - 1) * productsPerPage + 1 : 0 }} -
            {{ Math.min(currentPage * productsPerPage, filteredProducts.length) }}
            de {{ filteredProducts.length }} productos
        </p> 
        
        <div class="sort">
          <p class="titSort">Ordenar por:</p>
          <select v-model="sortOption">
            <option value="Todos">Todos</option>
            <option value="Menor Precio">Menor Precio</option>
            <option value="Mayor Precio">Mayor Precio</option>
          </select>
        </div>
      </div>

      <!-- MODAL DE ADVERTENCIA / VALIDACIÓN -->
            <transition name="modal-fade">
              <div v-if="isValidationModalOpen" class="brand-modal-overlay" @click.self="isValidationModalOpen = false">
                <div class="brand-modal-content validation-modal">
                  <div class="brand-modal-header">
                    <div class="brand-modal-title">
                      <h2>˖᯽ ݁˖ Un último detalle ˖᯽ ݁˖</h2>
                    </div>
                    <button class="brand-modal-close" @click="isValidationModalOpen = false" aria-label="Cerrar modal">×</button>
                  </div>

                  <div class="brand-modal-body text-center modal-valid">
                    <p class="txt-mod">
                      {{ validationMessage }}
                    </p>
                    <button class="order-btn" @click="isValidationModalOpen = false" style="max-width: 200px; margin: 0 auto;">
                      Entendido
                    </button>
                  </div>
                </div>
              </div>
            </transition>

      <!-- GRID Y CARDS -->
      <div class="product-grid">
        <div class="card-catal" 
          v-for="product in paginatedProducts" 
          :key="`${product.id}-${product.categorySource || 'item'}`" >

          <!-- BADGE DE STOCK -->
          <span class="badge stock" :class="{ out: !product.stock }">
            {{ product.stock ? 'Disponible' : 'Pre-orden' }}
          </span>

          <!-- GALERÍA DE IMÁGENES -->
          <div class="product-gallery">
            <img class="main-product-image" 
              :src="activeView[product.id] === 'swatch'
                ? selectedSwatchImages[product.id]
                : selectedImages[product.id] || product.image" 
                :alt="product.name" />

            <!-- Maquillaje con Swatch -->
            <div v-if="selectedShade[product.id] && selectedSwatchImages[product.id]" class="gallery-thumbs">
              <img class="thumb" 
                :class="{ active: activeView[product.id] !== 'swatch' }" 
                :src="selectedImages[product.id]"
                @click="activeView[product.id] = 'product'" />
              <img class="thumb" 
                :class="{ active: activeView[product.id] === 'swatch' }" 
                :src="selectedSwatchImages[product.id]"
                @click="activeView[product.id] = 'swatch'" />
            </div>
          </div>

          <!-- ENCABEZADO DE LA CARD -->
          <div class="card-content">
            <small class="category">{{ product.brand }}</small>
            <div class="title-row">
              <h3>{{ product.name }}</h3>
              
              <span class="price">
                ${{ (product.categorySource === 'perfumes' || product.categorySource === 'skincare') && product.tam?.length
                  ? (selectedSize[product.id]?.price || product.tam[0]?.price) 
                  : product.price }}
              </span>
            </div>
          </div>

          <!-- PERFUMES -->
          <div v-if="product.categorySource === 'perfumes'" class="perfume-info">
            <p class="perfume-type" v-if="product.type">
              Tipo: <span class="perfume-typ">{{ product.type }}</span>
            </p>
            <div class="perfume-tags">
              <p class="perfume-type" v-if="product.family">
                Familia: <span class="perfume-typ">{{ product.family }}</span>
              </p>
              <p class="perfume-type" v-if="product.gender">
                Género: <span class="perfume-typ">{{ product.gender }}</span>
              </p>
            </div>

            <div class="space-card" v-if="product.Keynotes">
              <p class="perfume-type">Notas principales:</p>
              <div class="notes-tags">
                <span v-for="note in product.Keynotes.split(',')" :key="note">
                  {{ note.trim() }}
                </span>
              </div>
            </div>

            <div v-if="product.tam?.length">
              <p class="perfume-type">Tamaños disponibles:</p>
              <div class="sizes-wrapper">
                <button v-for="size in product.tam" 
                  :key="size.ml" class="size-btn"
                  :class="{ active: selectedSize[product.id]?.ml === size.ml }"
                  @click="selectedSize[product.id] = size">
                  {{ size.ml }}ml
                </button>
              </div>
            </div>

            <!--<button class="order-btn" @click="makeOrder(product)" :class="{ preorder: selectedShade[ product.id] && !selectedShadeStock[product.id] }" >
              {{ selectedShade[ product.id]
                ? (selectedShadeStock [product.id]
                  ? 'ꕤ  Pedir Ahora  ꕤ'
                  : 'ꕤ  Pre-ordena  ꕤ')
                : (product.stock
                  ? 'ꕤ  Pedir Ahora  ꕤ'
                  : 'ꕤ  Pre-ordena  ꕤ')
              }}
            </button> -->
          </div>

          <!-- MAQUILLAJE -->
          <div v-else-if="product.categorySource === 'maquillaje'" class="makeup-info">
            <div v-if="product.shades?.length" class="shade-wrapper">
              <div class="shade-container"> 
                <span v-for="shade in product.shades" 
                  :key="shade.name" 
                  class="shade"
                  :style="{ backgroundColor: shade.color }"
                  :class="{ 
                    soldOut: !shade.stock, 
                    active: selectedShade[product.id] === shade.name
                  }"
                  :title="shade.name"
                  @click="selectShade(product.id, shade)"
                ></span> 
              </div> 
            </div>
            
            <div v-if="product.shades?.length" class="shade-info">
              <p class="shade-count">{{ product.shades.length }} tonos disponibles</p>
              <p v-if="selectedShade[product.id]" class="selected-shade">
                Tono: 
                <span :style="{ color: selectedShadeColor[product.id] }">
                  {{ selectedShade[product.id] }}
                </span>
              </p>
            </div>
            <div class="title-row">
              <p class="shade-count" > Formato:  <span style="font-weight: 600;">{{ product.formato }} </span> </p>
              <p class="shade-count"> Tamaño: <span style="font-weight: 600;"> {{ product.tam }} </span> </p> 
            </div>

            <!--<button class="order-btn" @click="makeOrder(product)" :class="{ preorder: selectedShade[ product.id] && !selectedShadeStock[product.id] || (!selectedShade[product.id] && !product.stock)}" >
              {{ selectedShade[ product.id]
                  ? (selectedShadeStock [product.id]
                    ? 'ꕤ  Pedir Ahora  ꕤ'
                    : 'ꕤ  Pre-ordena Tono  ꕤ')
                  : (product.stock
                    ? 'ꕤ  Pedir Ahora  ꕤ'
                    : 'ꕤ  Pre-ordena  ꕤ')
              }}
            </button> -->
          </div>
          
          <!-- SKINCARE -->
          <div v-else-if="product.categorySource === 'skincare'" class="skincare-info">
            <div class="title-row" style="margin-bottom: 5px;">
              <p class="shade-count" v-if="product.routine"> 
                <span style="">{{ product.routine }} </span> 
              </p>
            </div>
            <div class="" v-if="product.skinType?.length">
              <div class="no-tags">
                <p class="perfume-type">Para piel:</p>
                  <span v-for="type in product.skinType" :key="type"> - {{ type }}  </span>
              </div>
            </div>
            <div  v-if="product.concerns?.length">
              <p class="perfume-type" style="margin-bottom: 1px;">Ideal para:</p>
                <div class="notes-tags">
                  <span v-for="concern in product.concerns" :key="concern"> {{ concern }} </span>
                </div>
            </div>
            <div v-if="product.tam?.length" style="margin-top: 10px; margin-bottom: 15px;">
              <p class="perfume-type">Tamaños disponibles:</p>
                <div class="sizes-wrapper">
                  <button v-for="size in product.tam" :key="size.ml" 
                    class="size-btn"
                    :class="{ active: selectedSize[product.id]?.ml === size.ml }"
                    @click="selectedSize[product.id] = size"> {{ size.ml }}ml
                  </button>
                </div>
            </div>
            <!--<button class="order-btn" @click="makeOrder(product)" :class="{ preorder: !product.stock } || (!selectedShade[product.id] && !product.stock)">
              {{ product.stock ? 'ꕤ  Pedir Ahora  ꕤ' : 'ꕤ  Pre-ordena  ꕤ' }}
            </button> -->
          </div>

          <!-- SNACKS -->
          <div v-else-if="product.categorySource === 'snacks'" class="snack-info">
            <div class="title-row" style="margin-top: 5px; margin-bottom: 5px;">
              <p class="shade-count" v-if="product.weight"> 
                Contenido: <span style="font-weight: 600;">{{ product.weight }}</span> 
              </p> 
            </div>

            <!-- Etiquetas de sabor -->
            <div class="space-card" v-if="product.flavorTags?.length">
              <div class="notes-tags">
                <span v-for="tag in product.flavorTags" :key="tag"
                      style=" color: #333; ">
                  {{ tag }}
                </span>
                <!-- Tag especial para picante -->
                <span v-if="product.isSpicy" 
                      style="background-color: #ffe4e6; color: #e11d48; font-size: 0.8rem; font-weight: bold;">
                  🌶️ Picante
                </span>
              </div>
            </div>

            <div v-if="product.sabores?.length" style="margin-top: 1px; margin-bottom: 2px;">
              <p class="perfume-type">Opciones disponibles:</p>
              <div class="sizes-wrapper" style="flex-wrap: wrap; gap: 8px; margin-top: 5px;">
                <button v-for="sabor in product.sabores" 
                  :key="sabor.name" 
                  class="size-btn"
                  :class="{ 
                    active: selectedFlavor[product.id] === sabor.name,
                    soldOut: !sabor.stock 
                  }"
                  @click="selectFlavor(product.id, sabor)">
                  {{ sabor.name }}
                </button>
              </div>
            </div>

            <button class="order-btn" @click="makeOrder(product)" :class="{ preorder: !product.stock }">
              {{ product.stock ? 'Pedir ahora' : 'Pre-ordena' }}
            </button>
          </div>

          <!-- SETS -->
          <template v-else-if="product.isSet">
            <div class="card-content" style="padding-top: 0;">
              <div class="set-details-badge" style="margin-bottom: 6px;">
                <span v-if="product.totPz" class="set-item-chip full-chip txtTotCount">
                  🛍️ {{ product.totPz }} Piezas 
                </span>
                <span> </span>
                <span v-if="product.fullSizeCount" class="set-item-chip full-chip txtSizeCount" >
                  💎 {{ product.fullSizeCount }} Full
                </span>
                <span v-if="product.miniSizeCount" class="set-item-chip mini-chip txtSizeCount" >
                  💎 {{ product.miniSizeCount }} Mini
                </span>
                <span v-if="product.dlxSizeCount" class="set-item-chip mini-chip txtSizeCount" >
                  💎 {{ product.dlxSizeCount }} Deluxe
                </span>
              </div>
              <p v-if="product.descriptionSet" class="shade-count" style="margin-bottom: 12px;">
                {{ product.descriptionSet }}
              </p>
              
              <!--<button class="order-btn" @click="makeOrder(product)" :class="{ preorder: !product.stock } || (!selectedShade[product.id] && !product.stock)">
                {{ product.stock ? 'ꕤ  Pedir Ahora. ꕤ' : 'ꕤ  Pre-ordenar Set  ꕤ' }}
              </button> -->
            </div>
          </template>




            


            <button class="order-btn" @click="makeOrder(product)" :class="{ preorder: selectedShade[ product.id] && !selectedShadeStock[product.id] }" >
              {{ selectedShade[ product.id]
                ? (selectedShadeStock [product.id]
                  ? 'ꕤ  Pedir ahora  ꕤ'
                  : 'ꕤ  Pre-ordena  ꕤ')
                : (product.stock
                  ? 'ꕤ  Pedir ahora  ꕤ'
                  : 'ꕤ  Pre-ordena  ꕤ')
              }}
            </button>





        

        </div>
      </div>

      <div class="pagination" v-if="totalPages > 1">
        <button @click="prevPage" :disabled="currentPage === 1"> ❮ </button>
        <button v-for="page in totalPages" :key="page" @click="currentPage = page" :class="{ active: currentPage === page }">
          {{ page }}
        </button>
        <button @click="nextPage" :disabled="currentPage === totalPages" style="font-weight:600;">
          ❯
        </button>
      </div>
    </main>
  </section>

  <section style="padding-top: 0px;">
    <Footer />
  </section>
</template>

<script setup>
import '@/styles/catalogo.css'
// 1. IMPORTAMOS VUE ROUTER Y ONMOUNTED
import { computed, ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { products as maquillajeProducts } from '@/data/maquillaje';
import { products as perfumesProducts } from '@/data/perfumes';
import { products as skincareProducts } from '@/data/skincare';
import { products as snacksProducts } from '@/data/snacks';
import { products as setsProducts } from '@/data/sets';


import BtnFlotWA from '@/components/BtnFlotWA.vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

// 2. INICIALIZAMOS EL ROUTER
const route = useRoute()
const router = useRouter()

const phoneNumber = '522283616313'

// DICCIONARIO DE BANNERS DINÁMICOS
const brandBanners = {
  'Todas': '/banners/explora.png',
  'Armani': '/banners/armani.png',
  'Benefit': '/banners/benefit.png',
  'Charlotte Tilbury': '/banners/charlotte.png',
  'Dior': '/banners/dior.png',
  'ELF': '/banners/elf.png',
  'Fenty': '/banners/fenty.png',
  'Gisou': '/banners/gisou.png',
  'Givenchy': '/banners/givenchy.png',
  'Gucci': '/banners/gucci.png',
  'Guerlain': '/banners/guerlain.png',
  'Haus Labs': '/banners/hauslabs.png',
  'Hourglass': '/banners/hourglass.png',
  'Huda': '/banners/huda.png',
  'Kayali': '/banners/kayali.png',
  'Kiko Milano': '/banners/kiko.png',
  'Kosas': '/banners/kosas.png',
  'Lys': '/banners/lys.png',
  'Marc Jacobs': '/banners/marcjacobs.png',
  'Mario': '/banners/mario.png',
  'Merit': '/banners/merit.png',
  'Milk': '/banners/milk.png',
  'One Size': '/banners/onesize.png',
  'Patrick Ta': '/banners/patrick.png',
  'Prada': '/banners/prada.png',
  'Rare Beauty': '/banners/rare.png',
  'Refy': '/banners/refy.png',
  'Rem': '/banners/rem.png',
  'Rhode': '/banners/rhode.png',
  'Saie': '/banners/saie.png',
  'Soldejaneiro': '/banners/soldejaneiro.png',
  'Summer': '/banners/summer.png',
  'Toofaced': '/banners/toofaced.png',
  'Touchland': '/banners/touchland.png',
  'Tower': '/banners/tower.png',
  'Victoria´s Secrets': '/banners/vs.png',
  'YSL': '/banners/ysl.png',
}

// MARCAS DESTACADAS PARA EL SCROLLBAR SUPERIOR
const featuredBrands = ref([
  { name: 'Todas' },
  { name: 'Rhode' },
  { name: 'Dior' },
  { name: 'ELF' },
]);

// ESTADOS 
const isBrandModalOpen = ref(false)
const modalBrandSearch = ref('')
const selectedLetter = ref('ALL')

const selectedBrand = ref('Todas')
const selectedCategory = ref('Todos')
const stockFilter = ref('all')
const selectedGama = ref('Todas')
const sortOption = ref('Todos')
const searchQuery = ref('')

const selectedImages = ref({})
const selectedShade = ref({})
const selectedShadeColor = ref({})
const selectedShadeStock = ref({})
const selectedSwatchImages = ref({})
const activeView = ref({})
const selectedSize = ref({})
const selectedFlavor = ref({})
const selectedFlavorStock = ref({})

// MODAL DE VALIDACIÓN
const isValidationModalOpen = ref(false)
const validationMessage = ref('')

const categories = [
  'Todos',
  'Lippies',
  'Rubores',
  'Correctores',
  'Fijadores',
  'Bases',
  'Rostro',
  'Cabello',

  'Limpiadores',
  'Body Mist'

]

const currentPage = ref(1)
const productsPerPage = 30

// --- CÁLCULO DE PRODUCTOS Y MARCAS ---
const allRawProducts = computed(() => {
  const mList = Array.isArray(maquillajeProducts) ? maquillajeProducts.map(p => ({ ...p, categorySource: 'maquillaje' })) : [];
  const pList = Array.isArray(perfumesProducts) ? perfumesProducts.map(p => ({ ...p, categorySource: 'perfumes' })) : [];
  const sList = Array.isArray(skincareProducts) ? skincareProducts.map(p => ({ ...p, categorySource: 'skincare' })) : [];
  const snList = Array.isArray(snacksProducts) ? snacksProducts.map(p => ({ ...p, categorySource: 'snacks' })) : [];
  const stList = Array.isArray(setsProducts) ? setsProducts.map(p => ({ ...p, categorySource: 'sets' })) : [];

  return [...mList, ...pList, ...sList, ...snList, ...stList ];
});

// EXTRAE TODAS LAS MARCAS ÚNICAS
const allBrandsList = computed(() => {
  const brandsSet = new Set()
  allRawProducts.value.forEach(p => {
    if (p.brand && p.brand.trim()) {
      brandsSet.add(p.brand.trim())
    }
  })
  return ['Todas', ...Array.from(brandsSet).sort((a, b) => a.localeCompare(b))]
})


// Convierte para una URL limpia
const formatBrandForUrl = (name) => {
  return name.toLowerCase().replace(/\s+/g, '-');
}

// Convierte el texto de la URL de vuelta al nombre original 
const getBrandFromUrl = (urlBrand) => {
  if (!urlBrand) return 'Todas';
  const found = allBrandsList.value.find(b => formatBrandForUrl(b) === urlBrand);
  return found || 'Todas';
}

// LEER LA URL AL CARGAR LA PÁGINA
onMounted(() => {
  // Asegúrate de que en tu archivo de rutas esté configurado como /Marcas/:marca?
  if (route.params.marca) {
    selectedBrand.value = getBrandFromUrl(route.params.marca);
  }
})

// --- MÉTODOS DE SELECCIÓN ---

// Método centralizado para seleccionar un tono
const selectShade = (productId, shade) => {
  selectedImages.value[productId] = shade.image
  selectedSwatchImages.value[productId] = shade.swatchImage
  selectedShade.value[productId] = shade.name
  selectedShadeColor.value[productId] = shade.color
  selectedShadeStock.value[productId] = shade.stock
  activeView.value[productId] = 'product'
}

// Método para seleccionar marca Y CAMBIAR LA URL
const selectBrand = (brandName) => {
  selectedBrand.value = brandName
  isBrandModalOpen.value = false

  // Cambia la URL en el navegador
  if (brandName === 'Todas') {
    router.push({ path: '/Marcas' })
  } else {
    router.push({ path: `/Marcas/${formatBrandForUrl(brandName)}` })
  }
}
//Seleecionar sabores en snacks
const selectFlavor = (productId, sabor) => {
  selectedFlavor.value[productId] = sabor.name
  selectedFlavorStock.value[productId] = sabor.stock
  if (sabor.image) {
    selectedImages.value[productId] = sabor.image
  }
}



// --- RESTO DE COMPUTADAS Y MÉTODOS ---

// BANNERS DINÁMICOS
const currentBrandData = computed(() => {
  const brandName = selectedBrand.value;
  const bannerPath = brandBanners[brandName] || brandBanners['Todas'];
  
  return {
    name: brandName,
    banner: bannerPath
  };
});

// LISTA DE LETRAS DISPONIBLES EN TUS MARCAS
const availableLetters = computed(() => {
  const letters = new Set()
  allBrandsList.value.forEach(b => {
    if (b !== 'Todas') {
      const firstChar = b.charAt(0).toUpperCase()
      if (/[A-Z]/.test(firstChar)) {
        letters.add(firstChar)
      }
    }
  })
  return Array.from(letters).sort()
})

// MARCAS FILTRADAS EN EL MODAL 
const modalFilteredBrands = computed(() => {
  return allBrandsList.value.filter(b => {
    const matchesSearch = b.toLowerCase().includes(modalBrandSearch.value.toLowerCase().trim())
    const matchesLetter = selectedLetter.value === 'ALL' || b.toUpperCase().startsWith(selectedLetter.value)
    return matchesSearch && matchesLetter
  })
})

/*const getProductPrice = (p) => {
  if (p.categorySource === 'perfumes' && p.tam?.length) {
    return selectedSize.value[p.id]?.price || p.tam[0]?.price || 0;
  }
  return p.price || 0;
};*/

const getProductPrice = (p) => {
  // Ahora valida tanto perfumes como skincare
  if ((p.categorySource === 'perfumes' || p.categorySource === 'skincare') && p.tam?.length) {
    return selectedSize.value[p.id]?.price || p.tam[0]?.price || 0;
  }
  return p.price || 0;
};


const filteredProducts = computed(() => {
  let filtered = [...allRawProducts.value]

  if (selectedBrand.value !== 'Todas') {
    filtered = filtered.filter(p => p.brand && p.brand.trim().toLowerCase() === selectedBrand.value.trim().toLowerCase())
  }

  const search = searchQuery.value.toLowerCase().trim()
  if (search) {
    const words = search.split(/\s+/)
    filtered = filtered.filter(product => {
      const searchableText = [ 
        product.name, 
        product.brand, 
        product.category,
        product.gama,
        ...(product.shades?.map(shade => shade.name) || [])
      ].join(' ').toLowerCase()
      return words.every(word => searchableText.includes(word))
    })
  }

  if (selectedCategory.value !== 'Todos' && !searchQuery.value.trim()) {
    filtered = filtered.filter(product => product.category === selectedCategory.value)
  } 

  if (selectedGama.value !== 'Todas') {
    filtered = filtered.filter(product => product.gama === selectedGama.value)
  }

  if (stockFilter.value === 'inStock') {
    filtered = filtered.filter(product => product.stock)
  }
  if (stockFilter.value === 'outStock') {
    filtered = filtered.filter(product => !product.stock)
  }

  if (sortOption.value === 'Menor Precio') {
    filtered.sort((a, b) => getProductPrice(a) - getProductPrice(b))
  }
  if (sortOption.value === 'Mayor Precio') {
    filtered.sort((a, b) => getProductPrice(b) - getProductPrice(a))
  }

  return filtered
})

const totalPages = computed(() => Math.ceil(filteredProducts.value.length / productsPerPage))

const paginatedProducts = computed(() => {
  const start = (currentPage.value - 1) * productsPerPage
  return filteredProducts.value.slice(start, start + productsPerPage)
})

const filtersOpen = ref(false)

const closeMobileFilters = () => {
  filtersOpen.value = false
}

const selectMobileCategory = (category) => {
  selectedCategory.value = category
  searchQuery.value = '' 
  filtersOpen.value = false
}

const clearFilters = () => {
  selectedBrand.value = 'Todas'
  selectedCategory.value = 'Todos'
  selectedGama.value = 'Todas'
  stockFilter.value = 'all'
  searchQuery.value = ''
  // También limpiamos la URL
  router.push({ path: '/Marcas' })
}

watch([selectedBrand, selectedCategory, selectedGama, stockFilter, sortOption, searchQuery], () => {
  currentPage.value = 1
})

const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++
}

const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--
}

//BTN CREAR ORDEN WPP
const makeOrder = (product) => {
  //Validaciones
  if (product.categorySource === 'maquillaje' && product.shades?.length) {
    if (!selectedShade.value[product.id]) {
      validationMessage.value = 'Bestie ʚɞ,\n Selecciona un tono antes de realizar tu pedido ᯓ★ '
      isValidationModalOpen.value = true
      return
    }
  }
  if ((product.categorySource === 'perfumes' || product.categorySource === 'skincare') && product.tam?.length) {
    if (!selectedSize.value[product.id]) {
      validationMessage.value = 'Bestie ʚɞ, \nSelecciona un tamaño antes de realizar tu pedido ᯓ★ '
      isValidationModalOpen.value = true
      return
    }
  }

  const selectedShadeName = selectedShade.value[product.id]
  const shadeStock = selectedShadeStock.value[product.id]
  
  const currentSizeObj = selectedSize.value[product.id] || product.tam?.[0]
  const sizeName = selectedSize.value[product.id]?.ml ? `${selectedSize.value[product.id].ml}ml` : ''
  const currentPrice = selectedSize.value[product.id]?.price || product.oldPrice || product.price

  const orderType = selectedShadeName
    ? (shadeStock ? 'pedido' : 'Pre-orden')
    : (product.stock ? 'pedido' : 'preordena')

  let message = `Hola, me interesa hacer ${orderType}  de:\n` +
                `🛍 Producto: ${product.name}\n` +
                `🏷 Marca: ${product.brand}`
  if (sizeName) {
    message += `\n Tamaño: ${sizeName}`
  }
  if (selectedShadeName) {
    message += `\n 💄 Tono: ${selectedShadeName}`
  }
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
  window.open(url, '_blank')
}


</script>